import VersionModelEntity from "../../../domain/entities/VersionModelEntity";

const fromJson = (versionmodel: any): VersionModelEntity => {
    const lowerCaseName = versionmodel.version ? String(versionmodel.version).toLowerCase() : "";

    return {
        id: versionmodel.id,
        name: lowerCaseName,
    };
};

const toJson = (versionmodel: VersionModelEntity): any => {
    return {
        id: versionmodel.id,
        versionmodel: versionmodel.name,
    };
};

export default {
    fromJson,
    toJson,
};
